import { Injectable } from '@angular/core'

import { Subject } from 'rxjs/Subject'
import { Subscription } from 'rxjs/Subscription'

@Injectable()
export class LoadingDelegate {

  private subject: Subject<Object>

  constructor () {
    this.subject = new Subject<Object>()

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.subscribe = this.subscribe.bind(this)
  }

  show (message?: string) {
    this.subject.next({show: true, message: message || ''})
  }

  hide () {
    this.subject.next({show: false})
  }

  subscribe (fn): Subscription {
    return this.subject.asObservable().subscribe(fn)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/loading-delegate.service.ts